import { graphql } from '../gql';

export const CHECK_FORM_INTEGRITY = graphql(`
  query checkFormIntegrity($email: String!) {
    checkFormIntegrity(email: $email)
  }
`);
